import { common, projectType } from "@/util/global"
import { Random } from "xhwebtool"
import { RSSign, Encrypt } from './sign'
import CryptoJS from "crypto-js";
import { lang } from "@/util/base";
import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();

// 完善data
export const perfectData = (data, type) => {
    try {
        const commonData = {
            nonce: Random.randomString(),
            version: common.sdkVersion,
            sign_type: common.signType,
        };
        data = {
            ...commonData,
            ...data,
        };
        data.sign = RSSign(data, projectType().appKey && !type ? projectType().appKey : projectType().initKey);
        return data;
    } catch (error) {
        // Handle the error here
        console.error("An error occurred while perfecting data:", error);
        // Optionally, rethrow the error
        throw error;
    }
};

// head头请求数据
export const headData = async (url) => {
    const data = {
        biz_site_id: projectType().name, // 站点标识，后台配置获取，联系技术提供
        nonce: Random.randomString(),
        sys_language: cookies.get("XH-WEB").page_lang || lang(), // 优先获取玩家选择语言，为空获取系统语言
        sign_type: "md5", // 签名方式
        activity_label: projectType().activityLabel,// 活动标签，后台配置获取，联系技术提供
    }
    // 获取服务器时间仅是初始化的时候调用一次用于修正客户端时间，一次生命周期内，不用进行第二次调用
    if (url.indexOf('/apiv1/comm/init') !== -1) {
        return {
            ...data,
            ts: projectType().serverTime
        }
    } else {
        return {
            ...data,
            ts: new Date().getTime() + projectType().differenceTime
        }
    }
}

// 请求头header sign
export const Sign = (headData) => {
    return RSSign(headData, projectType().initKey)
}

// 请求头header ClientInfo
export const ClientInfo = (headData) => {
    return Encrypt(headData, CryptoJS.MD5(Sign(headData) + projectType().aesKey).toString(), CryptoJS.MD5(Sign(headData) + projectType().aesKey).toString().slice(-16))
} 